import React from 'react';

interface SummaryContextValue {
    contexts: Array<{
        summaryId: boolean | null,
        updateRegistered: Function | null,
    }>,
    indexMapper?: object,
    summaryId: boolean | null,
    summaryItemsComparisonEnabled: boolean,
    updateRegistered: Function | null,
}

const defaultSummaryContextValue: SummaryContextValue = {
    contexts: [],
    summaryId: null,
    summaryItemsComparisonEnabled: false,
    updateRegistered: null,
};
const Context = React.createContext(defaultSummaryContextValue);

const ContextProvider = (props) => {

    const { propsToInject, children } = props;

    return (
        <Context.Provider
            value={{ ...propsToInject }}
        >
            { children }
        </Context.Provider>
    );
};

export { ContextProvider, Context };